import { Injectable } from '@angular/core';
/**
 * jwt import.
 */
import { JwtHelperService } from '@auth0/angular-jwt';
/**
 * constant import
 */
import { COUNTRIES_LIST, COUNTRIES_NAME, FIELD_TYPE, LOCAL_STORAGE_COUNTRY, PH_AZ_NR_NPND_1 } from './constant/app.constant';
import { BehaviorSubject } from 'rxjs';
import { UserDetail } from './models/attendant.model';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  /**
   * to store current user phone number
   */
  public attendantCurrentPhoneNumber: string;
  /**
   * toggle to add auth token on interceptor or not
   */
  public addCustomAuthToken = false;

  /**
   * helper function to generate dispense list.
   */
  generateDispenseList(maxQuantity: number, size: number): number[] {
    const list: number[] = [];
    for (let i = size; i <= maxQuantity; i = i + size) {
      list.push(i);
    }
    return list;
  }
  /**
   * function to fetch decoded token
   */
  public decodeTokenFunc(token: string): any {
    const idToken = localStorage.getItem('doctorAuth');
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(idToken);
    return decodedToken;
  }
  public decodeFindDoctorTokenFunc(token: string): any {
    const idToken = localStorage.getItem('findDoctorAuth');
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(idToken);
    return decodedToken;
  }
  /**
   * function to validate number.
   */
  validateNumber(numberString: string): boolean {
    if (numberString === '' || isNaN(Number(numberString)) || Number(numberString) <= 0) {
      return false;
    }
    return true;
  }

  /**
   * mask the characters.
   */
  public hideCharacters(value: string, type: string): string {
    if (type === FIELD_TYPE.EMAIL) {
      const input = value.split('@');
      return input[0].length > 4 ?
      ('*'.repeat(input[0].length - 4) + input[0].substring(input[0].length - 4) + '@' + input[1]) : value;
    }
    let defaultReplacement = '*';
    if(sessionStorage.getItem('process') === PH_AZ_NR_NPND_1){
      defaultReplacement = 'X';
    }
    return value.length > 4 ? (defaultReplacement.repeat(value.length - 4) + value.substring(value.length - 4)) : value;
  }

  public getCurrentCountryString(): string {
    const countryCode = localStorage.getItem(LOCAL_STORAGE_COUNTRY.COUNTRY);
    let countryName = COUNTRIES_NAME[countryCode];
    if (!countryName) {
      countryName = COUNTRIES_LIST.PHILLIPPINS.name;
    }
    return countryName;
  }
  public getAttendantToken(): string | null {
    return localStorage.getItem('attendantToken');
  }


  checkForMalaysiaCountry(): boolean {
    return localStorage.getItem('country') === COUNTRIES_LIST.MALAYSIA.value;
  }
}
